import { RootStore } from 'common/interfaces/root';

export const rootInitState: RootStore = {
  lang: '',
  demo: false,
  error: null,
  loading: true,
};
